/**
 * Note names — FR-008.
 *
 * The MVP pool is the seven natural notes, with no sharps or flats;
 * accidentals are reserved for future difficulty levels.
 *
 * The Latin letter is the canonical written form (FR-066): it is what the note
 * pool stores, what an attempt records, and what every interface carries.
 * Do–Si rendering is presentation only and belongs to the client.
 */
export const NOTE_NAMES = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
export function isNoteName(value) {
    return typeof value === 'string' && NOTE_NAMES.includes(value);
}
//# sourceMappingURL=notes.js.map